import React from 'react';
import { MDXProvider } from '@mdx-js/react';

const HIDDEN_H2_HEADINGS = new Set(['product overview', 'changelog']);

const collectText = (node: React.ReactNode): string => {
  if (node === null || node === undefined) {
    return '';
  }
  if (typeof node === 'string' || typeof node === 'number') {
    return String(node);
  }
  if (Array.isArray(node)) {
    return node.map(collectText).join('');
  }
  if (React.isValidElement(node)) {
    return collectText((node.props as { children?: React.ReactNode }).children);
  }
  return '';
};

const HeadingH2 = (props: React.HTMLAttributes<HTMLHeadingElement>) => {
  const headingText = collectText(props.children).trim().toLowerCase();
  if (HIDDEN_H2_HEADINGS.has(headingText)) {
    return null;
  }
  return <h2 {...props} />;
};

const components = {
  h2: HeadingH2,
};

const DocContent = ({ Content }: { Content: React.ComponentType }) => {
  return (
    <MDXProvider components={components}>
      <Content />
    </MDXProvider>
  );
};

export default DocContent;
